import { T } from '@/i18n';
import { Empty, Panel } from '@/ui';
import { Link } from 'react-router-dom';

/**
 * Stage 2 ships the shell. Each of these is replaced by its screen in stages 3 to 6 of plan 0019.
 * Stage 0 is the router's catch-all: an address with no page, which is not a screen that is coming
 * and says so without naming a plan (U4).
 */
export default function Placeholder({ title, stage }: { title: string; stage: number }) {
  if (stage === 0)
    return (
      <>
        <div className="ph">
          <div>
            <h1>{T(title)}</h1>
            <div className="sub">{T('Sjekk adressen i nettleseren.')}</div>
          </div>
        </div>
        <Panel>
          <Empty>
            {T('Vi fant ingen side på denne adressen.')} <Link to="/">{T('Gå til forsiden')}</Link>
          </Empty>
        </Panel>
      </>
    );
  return (
    <>
      <div className="ph">
        <div>
          <h1>{title}</h1>
          <div className="sub">Kommer i plan 0019, stage {stage}</div>
        </div>
      </div>
      <Panel>
        <Empty>
          Skjermen er tegnet i prototypen og bygges i stage {stage}. Den gamle appen dekker den til da.
        </Empty>
      </Panel>
    </>
  );
}
